import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link, useSearchParams } from 'react-router-dom';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import ImageUpload from '../../components/ImageUpload';


const AddonForm = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoader, setIsLoader] = useState(false);
  const [appLoader, setAppLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [currency] = useState(process.env.REACT_APP_CURRENCY);
  const [items, setItems] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  

  const [apiData, setApiData] = useState({
    title: "",
    title_ar: "",
    price: "",
    pos_id: "",
    sort_order: 0,
    min_selection: "",
    max_selection: "",
    addon_id: searchParams.get('addon_id') || "",
    item_id: searchParams.get('item_id') || "",
  });


  useEffect(() => {
    if (id) {
      getSingleData();
    }
    // getItemsList();
  }, [id]);



  const getSingleData = async () => {
    try {
      setAppLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: `addon_items/${id}`,
      });
      const data = response.data;
      if (data.status) {
        const item = data.data;
        const firstMatchingItem = item.items.find(item => 
          item.item_id === apiData.item_id
        );
        setApiData({
          title: item.title,
          title_ar: item.title_ar,
          price: item.price,
          pos_id: item.pos_id,
          addon_id: item.addon_id,
          sort_order: firstMatchingItem?.sort_order,
          min_selection: firstMatchingItem?.min_selection,
          max_selection: firstMatchingItem?.max_selection,
          item_id: apiData.item_id,
        });

        
       
      } else {
        toast.error(data.message);
      }
      setAppLoader(false);
    } catch (error) {
      setAppLoader(false);
      console.log(error);
    }
  };



  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setApiData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  
  const handleImageChange = (name, file) => {
    setApiData((prevFormData) => ({
      ...prevFormData,
      [name]: file,
    }));
  };


  const submitForm = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    try {
      const formData = new FormData();
      Object.entries(apiData).forEach(([key, value]) => {
          formData.append(key, value);
      });
      console.log(formData);
      // formData.append("old_image", apiData.old_image);

      const response = await ApiService.request({
        method: 'POST',
        url:  `addon_items/createOrUpdate/${id || ''}`,
        data:formData
      });
     
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        // navigate("/addon_items");
        navigate(-1);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.error("Submit failed:", error);
      setIsLoader(false);
    }
  };



  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-xxl d-flex flex-stack"
        >
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? "Edit" : "Add New"} Modifier Option
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <a href="/dashboard" className="text-muted text-hover-primary">
                  Dashboard
                </a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <Link to={-1} className="text-muted text-hover-primary">
                  Modifier Options
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body pt-0">
              <form
                id="kt_modal_new_target_form"
                encType="multipart/form-data"
                method="POST"
                className="form fv-plugins-bootstrap5 fv-plugins-framework"
                onSubmit={submitForm}
              >
                <div className="row g-9 my-3">
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Title</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Enter Addon Title"
                      required
                      value={apiData.title}
                      name="title"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Title Arabic</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Enter Addon Title Ar"
                      required
                      value={apiData.title_ar}
                      name="title_ar"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Price</label>
                    <input
                      type="number" step={0.1}
                      className="form-control form-control-solid"
                      placeholder="Enter Addon Price"
                      required
                      value={apiData.price}
                      name="price"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className=" fs-6 fw-semibold mb-2">POS ID</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Enter  POS ID"
                      value={apiData.pos_id}
                      name="pos_id"
                      onChange={handleChange}
                    />
                  </div>
                  
                  <div class="col-md-6 fv-row fv-plugins-icon-container">
									        <label class="required fs-6 fw-semibold mb-2 text-info">Min Selection </label>
                      <input type="number" required class="form-control form-control-solid" placeholder="Enter Min Selection" name="min_selection" min="0"  value={apiData.min_selection}
                          onChange={handleChange}/>
                  </div>
                  <div class="col-md-6 fv-row fv-plugins-icon-container" id="maxField">
                      <label class="required fs-6 fw-semibold mb-2 text-info">Max Selection </label>
                      <input type="number" required class="form-control form-control-solid" placeholder="Enter Max Selection" name="max_selection" min={apiData.min_selection}  value={apiData.max_selection}
                          onChange={handleChange} />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2 text-info">Display Order</label>
                    <input
                      type="number"
                      className="form-control form-control-solid"
                      placeholder="Enter Addon Display Order"
                      required
                      value={apiData.sort_order}
                      name="sort_order"
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-3">
                        <span> Image</span>
                      </label>
                      <ImageUpload name="image" onImageChange={handleImageChange} defaultPreviewUrl={apiData.image} />
                      
                  </div>
               
                </div>
              

                {/* Form Actions */}
                <div className="row g-9 my-3">
                  <div className="text-center">
                    <button
                      type="button"
                      className="btn btn-light me-3"
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </button>
                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                      {isLoader ? (
                        <Loader size="20" text="Submitting" />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddonForm;
